import { createAction } from 'redux-actions';
import { socketEmit } from '../communication/actions';

// local
export const startCall = createAction(
  'COMMS_VIDEO_LOCAL_START_CALL',
  ({ type, from, to, customerVideoCall, customerChat }) => ({
    type, // audio / video
    from, // {id, name}
    to, // {id, name}
    customerVideoCall,
    customerChat,
  })
);
export const startCustomerCall = createAction('COMMS_VIDEO_LOCAL_START_CUSTOMER_CALL', ({ type, from, to }) => ({
  type, // audio / video
  from, // {id, name}
  to, // {id, name}
}));
export const failedCustomerCall = createAction('COMMS_VIDEO_LOCAL_START_CUSTOMER_CALL_FAILED', err => err);
export const acceptCall = createAction('COMMS_VIDEO_LOCAL_ACCEPT_CALL', uuid => ({ uuid }));
export const rejectCall = createAction('COMMS_VIDEO_LOCAL_REJECT_CALL', uuid => ({ uuid }));
export const cancelCall = createAction('COMMS_VIDEO_LOCAL_CANCEL_CALL', uuid => ({ uuid }));
export const endCall = createAction('COMMS_VIDEO_LOCAL_END_CALL', uuid => ({ uuid }));
export const toggleMic = createAction('COMMS_VIDEO_LOCAL_TOGGLE_MIC', isEnabled => ({ isEnabled }));
export const toggleCamera = createAction('COMMS_VIDEO_LOCAL_TOGGLE_CAMERA', isEnabled => ({ isEnabled }));
export const toggleScreenSharing = createAction('COMMS_VIDEO_LOCAL_TOGGLE_SCREEN_SHARING', isEnabled => ({
  isEnabled,
}));
export const toggleScreenSharingSuccess = createAction(
  'COMMS_VIDEO_LOCAL_TOGGLE_SCREEN_SHARING_SUCCESS',
  isEnabled => ({
    isEnabled,
  })
);
export const changeCameraFacingMode = createAction('COMMS_VIDEO_LOCAL_CHANGE_CAMERA_FACING_MODE', mode => ({
  mode,
}));
export const toggleCameraFacingMode = createAction('COMMS_VIDEO_LOCAL_TOGGLE_CAMERA_FACING_MODE');
export const setLocalStream = createAction('COMMS_VIDEO_LOCAL_SET_STREAM', stream => ({
  stream,
}));
export const resetCall = createAction('COMMS_VIDEO_RESET');
export const resetRemoteCall = createAction('COMMS_VIDEO_RESET_REMOTE');

// remote

export const newCustomerCall = createAction('COMMS_VIDEO_NEW_CUSTOMER_CALL', (data, uuid) => ({
  ...data,
  uuid,
}));

export const acceptNewCustomerCall = createAction('COMMS_VIDEO_NEW_CUSTOMER_CALL_ACCEPT', (data, uuid) => ({
  ...data,
  uuid,
}));

export const startCallByRemote = createAction('COMMS_VIDEO_REMOTE_START_CALL', ({ id, name, role }, type, uuid) => ({
  from: { id, name, role },
  type,
  uuid,
}));
export const acceptCallByRemote = createAction('COMMS_VIDEO_REMOTE_ACCEPT_CALL', ({ id, name, role }) => ({
  from: { id, name, role },
}));
export const sendViewerSettingsByRemote = createAction('COMMS_VIDEO_REMOTE_SEND_VIEWER_SETTINGS', ({ settings }) => ({
  settings,
}));
export const rejectCallByRemote = createAction('COMMS_VIDEO_REMOTE_REJECT_CALL', ({ id, name, role }, reason) => ({
  from: { id, name, role },
  reason,
}));
export const cancelCallByRemote = createAction('COMMS_VIDEO_REMOTE_CANCEL_CALL', ({ id, name, role }, reason) => ({
  from: { id, name, role },
  reason,
}));
export const endCallByRemote = createAction('COMMS_VIDEO_REMOTE_END_CALL', ({ id, name, role }) => ({
  from: { id, name, role },
}));
export const toggleRemoteMic = createAction('COMMS_VIDEO_REMOTE_TOGGLE_MIC', ({ id, name, role }, isEnabled) => ({
  from: { id, name, role },
  isEnabled,
}));
export const toggleRemoteCamera = createAction('COMMS_VIDEO_REMOTE_TOGGLE_CAMERA', ({ id, name, role }, isEnabled) => ({
  from: { id, name, role },
  isEnabled,
}));
export const toggleRemoteScreenSharing = createAction(
  'COMMS_VIDEO_REMOTE_TOGGLE_SCREEN_SHARING',
  ({ id, name, role }, isEnabled) => ({
    from: { id, name, role },
    isEnabled,
  })
);
export const changeRemoteCameraFacingMode = createAction(
  'COMMS_VIDEO_REMOTE_CHANGE_CAMERA_FACING_MODE',
  ({ id, name }, mode) => ({
    from: { id, name },
    mode,
  })
);
export const setRemoteStream = createAction('COMMS_VIDEO_REMOTE_SET_STREAM', (stream, from) => ({
  stream,
  from,
}));

export const updateCallId = createAction('COMMS_VIDEO_UPDATE_CALL_ID', (uuid, userId) => ({
  uuid,
  userId,
}));

export const toggleChatVisibility = createAction('COMMS_VIDEO_TOGGLE_CHAT_VISIBILITY', isChatVisible => isChatVisible);
export const initialized = createAction('COMMS_VIDEO_INITIALIZED');
export const sendWebRTCNegotiate = to => socketEmit('webrtc_negotiate', { to });
export const webrtcNegotiate = createAction('COMMS_VIDEO_WEBRTC_NEGOTIATE');

export const setStatus = createAction('COMMS_VIDEO_WEBRTC_STATUS', status => ({ status }));

export const callFinishActions = [rejectCall, cancelCall, endCall];
export const callFinishByRemoteActions = [rejectCallByRemote, cancelCallByRemote, endCallByRemote];

export default {
  startCall,
  startCustomerCall,
  acceptCall,
  rejectCall,
  cancelCall,
  endCall,
  toggleMic,
  toggleCamera,
  toggleScreenSharing,
  changeCameraFacingMode,
  toggleCameraFacingMode,
  setLocalStream,

  newCustomerCall,
  startCallByRemote,
  acceptCallByRemote,
  sendViewerSettingsByRemote,
  rejectCallByRemote,
  cancelCallByRemote,
  endCallByRemote,
  toggleRemoteMic,
  toggleRemoteCamera,
  toggleRemoteScreenSharing,
  changeRemoteCameraFacingMode,
  setRemoteStream,
  resetCall,
  resetRemoteCall,

  updateCallId,
  toggleChatVisibility,
  initialized,
  sendWebRTCNegotiate,
  webrtcNegotiate,
  callFinishActions,
  callFinishByRemoteActions,
};
